module.exports = __webpack_public_path__ + "img/CampusSeguro Icon-2.2ca54e5f.png";